// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orcamentos_AprovarOrcamentoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /orcamentos/aprovar_orcamento/{orc_id}
 *
 * No body; the orcamento ID arrives in the URL segment.
 */
import { registerContract } from './validate'

export interface Orcamentos_AprovarOrcamentoInput {}

registerContract('Orcamentos_AprovarOrcamentoInput', {})
